export const ZhChsNewsStrings = {
  NEWS: {
    NEWS_DATE: "NEWS_DATE_ZH",
    LIKE: "赞好",
    UNLIKE: "取消赞好",
    COMMENT: "留言",
    REPLY: "回覆",
    REPLY_COUNT: {
      ONE: "{{NUM}}个回覆",
      MULTIPLE: "{{NUM}}个回覆"
    },
    ATTACHMENTS_COUNT: {
      ONE: "{{NUM}}个附件",
      MULTIPLE: "{{NUM}}个附件"
    },
    REMOVE_COMMENT_SUCCESS_MSG: "删除留言成功"
  },

  VOTE: {
    VOTE_BTN: "投票",
    RESULT_BTN: "结果",
    VOTE_OPTION_DESC: {
      ONE: "({{PERCENTAGE}}%, {{COUNT}}个投票)",
      MULTIPLE: "({{PERCENTAGE}}%, {{COUNT}}个投票)"
    },
    SUCCESS_MSG: "感谢您的参与"
  },

  ERROR_MSG: {
    VOTE_NOT_YET_START: "投票尚未开始。请稍后再试",
    VOTE_EXPIRED: "活动已经结束",
    VOTE_RESULT_HIDDEN: "感谢您的参与",
    VOTED: "感谢您的参与",
    THREAD_LOCKED: "主题已锁定"
  }
};
